import type { PublicationCode } from '@/scopes/common/domain/models'
import { CatalogueType } from '@/scopes/common/domain/enums/CatalogueType'
import { PublicationCodes } from '@/scopes/common/domain/models'

export function getCatalogueTypeByPublicationCode(publicationCode: PublicationCode): CatalogueType {
  if (PublicationCodes.isSummerPublicationCode(publicationCode)) {
    return CatalogueType.Summer
  }
  if (PublicationCodes.isSunwebWinterPublicationCode(publicationCode)) {
    return CatalogueType.Winter
  }
  return CatalogueType.None
}
